<template>
    <!-- Agregar / editar un espacio: una sola página con secciones (diseño de la
         demo Desktop/nuevo-editaralojamiento). Editar lee GET accommodations/logged/:id
         y guarda con POST accommodations/update; agregar (sin :id) usa
         POST accommodations/create. Mismo formato de datos que el wizard de 9
         pasos que había antes (ya eliminado). -->
    <div class="ee">
        <div v-if="cargando" class="ee-cargando"><HyFLoader variant="inline" /></div>

        <!-- Perfil incompleto: igual que el wizard, primero hay que completar el perfil -->
        <div v-else-if="perfilIncompleto" class="ee-hero">
            <h1 class="ee-hero-title">{{ $t('dashboard.complete') }}</h1>
            <p class="ee-hero-sub">{{ $t('dashboard.text') }}</p>
            <button type="button" class="ee-btn ee-btn--primary" @click="irAPerfil">{{ $t('dashboard.button') }}</button>
        </div>

        <!-- No existe o no es suyo (la API responde lo mismo en los dos casos,
             para no revelar qué alojamientos existen): la página 404/403 del sitio. -->
        <NotFound v-else-if="errorCarga" variante="espacio" />

        <div v-else class="ee-lay ee-ed">
            <aside class="ee-side">
                <p v-if="unidad" class="ee-ed-unit">{{ unidad }}</p>
                <h1 ref="titulo" class="ee-side-title" tabindex="-1">{{ $t(tx('title_a')) }} <span class="ee-grad">{{ $t(tx('title_b')) }}</span></h1>
                <p class="ee-side-sub">{{ $t(tx('sub')) }}</p>

                <!-- Agregar: todavía no hay ficha, la tarjeta solo muestra cómo va quedando -->
                <div v-if="esNuevo" class="ee-ed-prev ee-ed-prev--nuevo">
                    <img v-if="portada" :src="portada" alt="">
                    <span v-else class="ee-ed-prev-ph" aria-hidden="true" v-html="ICON.photo"></span>
                    <span class="ee-ed-prev-b">
                        <span class="ee-ed-prev-t">{{ titulo }}</span>
                        <span class="ee-ed-prev-m">{{ embedded_mode ? $t('editor_espacio.nuevo.unit_address') : (d.direccion || $t('editor_espacio.nuevo.no_address')) }}</span>
                        <span class="ee-ed-ids"><span class="ee-badge ee-badge--wait">{{ $t('editor_espacio.nuevo.draft') }}</span></span>
                    </span>
                </div>
                <router-link v-else class="ee-ed-prev" :to="`/alojamiento/${d.idalojamiento}`" target="_blank" :aria-label="$t('editor_espacio.see_listing_of', { x: titulo })">
                    <img :src="portada" alt="">
                    <span class="ee-ed-prev-b">
                        <span class="ee-ed-prev-t">{{ titulo }}</span>
                        <span class="ee-ed-prev-m">{{ d.direccion }}</span>
                        <span class="ee-ed-ids">
                            <span class="ee-ed-id">ID <b>{{ d.idalojamiento }}</b></span>
                            <span v-if="d.idcodigo" class="ee-ed-id">{{ $t('editor_espacio.code') }} <b>{{ d.idcodigo }}</b></span>
                            <span :class="['ee-badge', aprobado ? 'ee-badge--ok' : 'ee-badge--wait']">{{ $t(aprobado ? 'editor_espacio.published' : 'editor_espacio.in_review') }}</span>
                        </span>
                    </span>
                </router-link>

                <nav class="ee-snav" :aria-label="$t('editor_espacio.sections')">
                    <p class="ee-snav-title">{{ $t('editor_espacio.sections') }}</p>
                    <ul class="ee-snav-list">
                        <li v-for="s in secciones" :key="s.id">
                            <a class="ee-snav-link" :href="`#sec-${s.id}`" :aria-current="actual === s.id ? 'page' : null" @click.prevent="irASeccion(s.id)">
                                <span v-html="ICON[s.icon]"></span><span>{{ $t(`editor_espacio.sec.${s.id}`) }}</span>
                                <span v-if="marcas[s.id]" class="ee-ed-dot" :aria-label="$t('editor_espacio.with_changes')"></span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </aside>

            <div class="ee-main">
                <div class="ee-crumb">
                    <router-link class="ee-crumb-back" :to="{ name: 'my-accommodations' }"><span v-html="ICON.back"></span>{{ $t('editor_espacio.my_spaces') }}</router-link>
                    <router-link v-if="!esNuevo" class="ee-btn ee-btn--ghost ee-btn--sm ee-ed-ver" :to="`/alojamiento/${d.idalojamiento}`" target="_blank"><span v-html="ICON.eye"></span>{{ $t('editor_espacio.see_listing') }}</router-link>
                </div>

                <div id="edCards" class="ee-cards">
                    <div v-if="embedded_mode" class="ee-ed-note ee-ed-note--soft"><span v-html="ICON.info"></span><div><p>{{ $t('editor_espacio.nuevo.unit_note') }}</p></div></div>
                    <!-- ══ Lo básico ══ -->
                    <section id="sec-basico" class="ee-card ee-ed-card" aria-labelledby="t-basico">
                        <div class="ee-card-head">
                            <span class="ee-ed-ico" aria-hidden="true" v-html="ICON.home"></span>
                            <div><h2 id="t-basico" class="ee-card-title">{{ $t('editor_espacio.sec.basico') }}</h2><p class="ee-card-desc">{{ $t('editor_espacio.desc.basico') }}</p></div>
                            <span v-if="marcas.basico" class="ee-ed-dirty">{{ $t('editor_espacio.with_changes') }}</span>
                        </div>
                        <div class="ee-pbs">
                            <EeBloque :titulo="$t('editor_espacio.b.tipo')" :ayuda="$t('editor_espacio.b.tipo_c')">
                                <div class="ee-ed-tipos" role="radiogroup" :aria-label="$t('editor_espacio.b.tipo')">
                                    <label v-for="t in tipos" :key="t.value" class="ee-ed-tipo">
                                        <input type="radio" name="tipo" :value="t.value" :checked="d.tipo === t.value" @change="cambiarTipo(t.value)">
                                        <span><b>{{ t.label }}</b><small>{{ t.desc }}</small></span>
                                    </label>
                                </div>
                                <div class="ee-pb-gap"></div>
                                <div :class="['ee-field', { 'is-invalid': errores.categoria }]">
                                    <div class="ee-control">
                                        <select id="f-categoria" v-model="d.categoria">
                                            <option v-for="c in categorias" :key="c.value" :value="c.value">{{ $t(c.translated) }}</option>
                                        </select>
                                        <label for="f-categoria">{{ $t('editor_espacio.f.category') }}</label>
                                    </div>
                                    <p class="ee-error" role="alert">{{ errores.categoria }}</p>
                                </div>
                            </EeBloque>

                            <EeBloque :titulo="$t('editor_espacio.b.modalidad')" :ayuda="$t('editor_espacio.b.modalidad_c')">
                                <div class="ee-seg" role="radiogroup" :aria-label="$t('editor_espacio.b.modalidad')">
                                    <label v-for="m in MODALIDADES" :key="m" class="ee-seg-o">
                                        <input type="radio" name="modalidad_tiempo" :value="m" :checked="d.modalidad_tiempo === m" @change="cambiarModalidad(m)">
                                        <span>{{ $t(`editor_espacio.mod.${m}`) }}</span>
                                    </label>
                                </div>
                                <p v-if="errores.modalidad_tiempo" class="ee-error ee-error--on" role="alert">{{ errores.modalidad_tiempo }}</p>
                                <div class="ee-pb-gap"></div>
                                <div class="ee-cts ee-cts--1">
                                    <EeContador id="c-tiempo_min" v-model="d.tiempo_min" :label="$t('editor_espacio.f.min_nights')" :min="1" :max="365" :disabled="d.modalidad_tiempo === 'mensual'" :nota="d.modalidad_tiempo === 'mensual' ? $t('editor_espacio.f.min_nights_monthly') : ''" />
                                </div>
                            </EeBloque>

                            <EeBloque :titulo="$t('editor_espacio.b.tamano')" :ayuda="$t('editor_espacio.b.tamano_c')" clase="ee-pb--last">
                                <div class="ee-grid-2 ee-grid-2--ct">
                                    <div :class="['ee-field', 'ee-has-suf', { 'is-invalid': errores.m2 }]">
                                        <div class="ee-control">
                                            <input id="f-m2" v-model.number="d.m2" type="number" min="1" inputmode="numeric" placeholder=" ">
                                            <label for="f-m2">{{ $t('editor_espacio.f.surface') }}</label>
                                            <span class="ee-suf" aria-hidden="true">m²</span>
                                        </div>
                                        <p class="ee-error" role="alert">{{ errores.m2 }}</p>
                                    </div>
                                    <EeContador id="c-maximo_huespedes" v-model="d.maximo_huespedes" :label="$t('editor_espacio.f.max_guests')" :min="1" :max="20" />
                                </div>
                                <div v-if="d.tipo !== 'entero'" class="ee-cts ee-cts--1">
                                    <EeContador id="c-rooms" :value="d.piezas.length" :label="$t('editor_espacio.f.rooms')" :min="0" :max="10" :nota="d.piezas.length === 0 ? $t('editor_espacio.f.studio') : ''" @input="cambiarHabitaciones" />
                                </div>
                            </EeBloque>
                        </div>
                    </section>

                    <!-- ══ Ubicación ══ -->
                    <section v-if="!embedded_mode" id="sec-ubicacion" class="ee-card ee-ed-card" aria-labelledby="t-ubicacion">
                        <div class="ee-card-head">
                            <span class="ee-ed-ico" aria-hidden="true" v-html="ICON.pin"></span>
                            <div><h2 id="t-ubicacion" class="ee-card-title">{{ $t('editor_espacio.sec.ubicacion') }}</h2><p class="ee-card-desc">{{ $t('editor_espacio.desc.ubicacion') }}</p></div>
                            <span v-if="marcas.ubicacion" class="ee-ed-dirty">{{ $t('editor_espacio.with_changes') }}</span>
                        </div>
                        <div class="ee-pbs">
                            <EeBloque :titulo="$t('editor_espacio.b.direccion')" :ayuda="$t('editor_espacio.b.direccion_c')">
                                <div class="ee-grid-2 ee-ed-dir">
                                    <div :class="['ee-field', 'ee-ed-ac', { 'is-invalid': errores.direccion }]">
                                        <div class="ee-control">
                                            <vue-google-autocomplete
                                                v-if="mapsListo"
                                                id="f-direccion"
                                                ref="autocomplete"
                                                types=""
                                                classname="ee-ac-input"
                                                placeholder=" "
                                                @placechanged="alElegirDireccion"
                                                @inputChange="alEscribirDireccion"
                                            />
                                            <input v-else id="f-direccion" :value="d.direccion" placeholder=" " disabled>
                                            <label for="f-direccion">{{ $t('editor_espacio.f.address') }}</label>
                                        </div>
                                        <p class="ee-error" role="alert">{{ errores.direccion }}</p>
                                    </div>
                                    <div :class="['ee-field', { 'is-invalid': errores.numero }]">
                                        <div class="ee-control">
                                            <input id="f-numero" v-model="d.numero" placeholder=" ">
                                            <label for="f-numero">{{ $t('editor_espacio.f.unit') }}</label>
                                        </div>
                                        <p class="ee-error" role="alert">{{ errores.numero }}</p>
                                    </div>
                                </div>
                            </EeBloque>

                            <EeBloque :titulo="$t('editor_espacio.b.mapa')" :ayuda="$t('editor_espacio.b.mapa_c')">
                                <div class="ee-ed-map" role="application" :aria-label="$t('editor_espacio.map_label')">
                                    <GmapMap v-if="mapsListo && posicion" :center="centro" :zoom="16" map-type-id="roadmap" :options="opcionesMapa" style="width: 100%; height: 100%">
                                        <GmapMarker :position="posicion" :draggable="true" @dragend="alMoverMarcador" />
                                    </GmapMap>
                                    <p v-else-if="esNuevo" class="ee-ed-map-empty"><span v-html="ICON.pin"></span>{{ $t('editor_espacio.nuevo.map_empty') }}</p>
                                </div>
                            </EeBloque>

                            <EeBloque v-if="esCaba" :titulo="$t('editor_espacio.b.caba')" :ayuda="$t('editor_espacio.b.caba_c')" clase="ee-pb--warn">
                                <div class="ee-field">
                                    <div class="ee-control">
                                        <input id="f-dni" v-model="d.dniTexto" placeholder=" ">
                                        <label for="f-dni">{{ $t('editor_espacio.f.registry') }}</label>
                                    </div>
                                </div>
                            </EeBloque>
                        </div>
                    </section>

                    <!-- ══ Precio (misma estructura que Step2Wizard / Step2WizardGarantia) ══ -->
                    <section id="sec-precio" class="ee-card ee-ed-card" aria-labelledby="t-precio">
                        <div class="ee-card-head">
                            <span class="ee-ed-ico" aria-hidden="true" v-html="ICON.money"></span>
                            <div><h2 id="t-precio" class="ee-card-title">{{ $t('editor_espacio.sec.precio') }}</h2><p class="ee-card-desc">{{ $t('editor_espacio.desc.precio') }}</p></div>
                            <span v-if="marcas.precio" class="ee-ed-dirty">{{ $t('editor_espacio.with_changes') }}</span>
                        </div>
                        <div class="ee-ed-precio">
                            <div class="ee-pc">
                                <p class="ee-pc-intro">{{ $t('wizard.s2.price-message-default') }}</p>
                                <div class="ee-pf">
                                    <div class="ee-pf-h"><label for="f-moneda">{{ $t('wizard.s2.currency-label') }}</label><button type="button" class="ee-hp" @click="ayudaDe('moneda')"><span v-html="ICON.info"></span>{{ $t('wizard.s2.currency-chip') }}</button></div>
                                    <div class="ee-field"><div class="ee-control ee-control--plain"><select id="f-moneda" v-model="d.moneda"><option v-for="m in monedas" :key="m" :value="m">{{ m }}</option></select></div></div>
                                </div>

                                <div v-if="mensual" class="ee-pb">
                                    <p class="ee-pb-t">{{ $t('wizard.s2.rent-section') }}</p><p class="ee-pb-c">{{ $t('wizard.s2.rent-section-caption') }}</p>
                                    <div v-for="c in camposPrecio" :key="c.k" class="ee-pf">
                                        <div class="ee-pf-h"><label :for="`f-${c.k}`">{{ $t(c.label) }}</label><button type="button" class="ee-hp" @click="ayudaDe(c.tip)"><span v-html="ICON.info"></span>{{ $t(c.chip) }}</button></div>
                                        <div :class="['ee-field', 'ee-has-suf', { 'is-invalid': errores[c.k] }]">
                                            <div class="ee-control ee-control--plain">
                                                <input :id="`f-${c.k}`" v-model="d[c.k]" type="number" min="0" inputmode="numeric" placeholder="0">
                                                <span class="ee-suf" aria-hidden="true">{{ d.moneda }}</span>
                                            </div>
                                            <p class="ee-error" role="alert">{{ errores[c.k] }}</p>
                                        </div>
                                    </div>
                                    <div class="ee-pf">
                                        <div class="ee-pf-h"><span class="ee-pf-l--b">{{ $t(modelo.tipo === 'viejo' ? 'wizard.s2.warranty-deposit' : 'wizard.s2.monthly-rent-value') }}</span><button type="button" class="ee-hp" @click="ayudaDe(modelo.tipo === 'viejo' ? 'garantiaVieja' : 'mensual')"><span v-html="ICON.info"></span>{{ $t('wizard.s2.chip-monthly') }}</button></div>
                                        <div class="ee-ed-ro"><b>{{ dinero(total, d.moneda) }}</b></div>
                                    </div>
                                </div>

                                <div v-if="diario" class="ee-pb">
                                    <p class="ee-pb-t">{{ $t('editor_espacio.b.precio_noche') }}</p><p class="ee-pb-c">{{ $t('editor_espacio.b.precio_noche_c') }}</p>
                                    <div class="ee-pf">
                                        <div class="ee-pf-h"><label for="f-arriendo_diario">{{ $t('wizard.s2.daily-lease') }}</label><button type="button" class="ee-hp" @click="ayudaDe('diario')"><span v-html="ICON.info"></span>{{ $t('wizard.s2.chip-daily') }}</button></div>
                                        <div :class="['ee-field', 'ee-has-suf', { 'is-invalid': errores.arriendo_diario }]">
                                            <div class="ee-control ee-control--plain">
                                                <input id="f-arriendo_diario" v-model="d.arriendo_diario" type="number" min="0" inputmode="numeric" placeholder="0">
                                                <span class="ee-suf" aria-hidden="true">{{ d.moneda }}</span>
                                            </div>
                                            <p class="ee-error" role="alert">{{ errores.arriendo_diario }}</p>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="conGarantia" class="ee-pb ee-pb--gar">
                                    <p class="ee-pb-t">{{ $t('wizard.s2.guarantee-section') }}</p><p class="ee-pb-c">{{ $t('wizard.s2.guarantee-section-caption') }}</p>
                                    <fieldset :class="['ee-pf', 'ee-pf--fs', { 'is-invalid': errores.garantia_meses }]">
                                        <legend>{{ $t('wizard.s2.guarantee-question') }}</legend><button type="button" class="ee-hp" @click="ayudaDe('garantia')"><span v-html="ICON.info"></span>{{ $t('wizard.s2.chip-guarantee') }}</button>
                                        <div class="ee-mo" role="radiogroup" :aria-label="$t('wizard.s2.guarantee-question')">
                                            <label v-for="m in GARANTIA_MESES" :key="m" class="ee-mo-o">
                                                <input v-model.number="d.garantia_meses" type="radio" name="garantia_meses" :value="m">
                                                <span><b>{{ mesesNum(m) }}</b><small>{{ mesesUnidad(m) }}</small></span>
                                            </label>
                                        </div>
                                        <p v-if="errores.garantia_meses" class="ee-error ee-error--on" role="alert">{{ errores.garantia_meses }}</p>
                                    </fieldset>
                                    <div class="ee-pf">
                                        <div class="ee-pf-h"><span class="ee-pf-l--b">{{ $t('wizard.s2.guarantee-amount') }}</span></div>
                                        <div class="ee-ed-ro"><b>{{ montoGarantia ? dinero(montoGarantia, d.moneda) : '—' }}</b></div>
                                    </div>
                                    <fieldset v-if="d.garantia_meses > 0" class="ee-pf ee-pf--fs">
                                        <legend>{{ $t('wizard.s2.guarantee-when') }}</legend><button type="button" class="ee-hp" @click="ayudaDe('cuando')"><span v-html="ICON.info"></span>{{ $t('wizard.s2.chip-guarantee-when') }}</button>
                                        <div class="ee-rd">
                                            <label v-for="g in GARANTIA_PAGO" :key="g" class="ee-rd-o"><input v-model="d.garantia_pago" type="radio" name="garantia_pago" :value="g"><span>{{ $t(`wizard.s2.guarantee-when-${g}`) }}</span></label>
                                        </div>
                                        <p v-if="errores.garantia_pago" class="ee-error ee-error--on" role="alert">{{ errores.garantia_pago }}</p>
                                    </fieldset>
                                </div>
                            </div>

                            <aside class="ee-ed-res">
                                <div :class="['ee-tipc', { 'is-flash': flash }]" aria-live="polite" ref="tipc">
                                    <span class="ee-tipc-i" aria-hidden="true" v-html="ICON.bulb"></span>
                                    <span><span class="ee-tipc-e">{{ $t('wizard.s2.tip-eyebrow') }}</span><b class="ee-tipc-t">{{ ayuda.t }}</b><span class="ee-tipc-x">{{ ayuda.x }}</span></span>
                                </div>
                                <div id="edResumen" aria-live="polite">
                                    <template v-if="mensual">
                                        <div class="ee-rs">
                                            <p class="ee-rs-t">{{ $t('wizard.s2.monthly-income-title') }}</p><p class="ee-rs-c">{{ $t('wizard.s2.monthly-income-caption') }}</p>
                                            <ul class="ee-rs-l">
                                                <li><span>{{ $t('wizard.s2.property-expense') }}</span><b>{{ dinero(d.arriendo, d.moneda) }}</b></li>
                                                <li><span>{{ $t('wizard.s2.basic-services') }}</span><b>{{ dinero(d.arriendo_basicos, d.moneda) }}</b></li>
                                                <li><span>{{ $t('wizard.s2.common-expenses') }}</span><b>{{ dinero(d.arriendo_comunes, d.moneda) }}</b></li>
                                                <li><span>{{ $t('wizard.s2.cleaning') }}</span><b>{{ dinero(d.arriendo_limpieza, d.moneda) }}</b></li>
                                                <li class="ee-rs-tot"><span>{{ $t('wizard.s2.monthly-receive') }}</span><b>{{ dinero(total, d.moneda) }}</b></li>
                                                <li v-if="modelo.tipo === 'viejo'" class="ee-rs-tot"><span>{{ $t('wizard.s2.warranty-deposit') }}</span><b>{{ dinero(total, d.moneda) }}</b></li>
                                            </ul>
                                        </div>
                                        <div v-if="modelo.descuenta" class="ee-rs ee-rs--orange">
                                            <div class="ee-rs-h"><div><p class="ee-rs-t">{{ $t('wizard.s2.warranty') }}</p><p class="ee-rs-c">{{ $t('wizard.s2.first-month-caption') }}</p></div><button type="button" class="ee-hp" @click="ayudaDe('primer')"><span v-html="ICON.info"></span>{{ $t('wizard.s2.chip-commission') }}</button></div>
                                            <ul class="ee-rs-l">
                                                <li><span>{{ $t('wizard.s2.first-month-gross') }}</span><b>{{ dinero(total, d.moneda) }}</b></li>
                                                <li class="ee-rs-minus"><span>{{ $t('wizard.s2.hf-commission', { rate: COMISION_LABEL }) }}</span><b>− {{ dinero(comision, d.moneda) }}</b></li>
                                                <li class="ee-rs-pay"><span>{{ $t('wizard.s2.first-month-payout') }}</span><b>{{ dinero(Math.max(0, total - comision), d.moneda) }}</b></li>
                                            </ul>
                                            <ol class="ee-rs-steps">
                                                <li>{{ $t('wizard.s2.warranty-step-1') }}<b>{{ $t('wizard.s2.warranty-ota') }}</b></li>
                                                <li>{{ $t('wizard.s2.warranty-step-2') }}</li>
                                                <li>{{ $t('wizard.s2.warranty-step-3') }}</li>
                                            </ol>
                                            <p class="ee-rs-note">{{ $t('wizard.s2.from-second-month', { amount: dinero(total, d.moneda) }) }}</p>
                                        </div>
                                        <div v-if="conGarantia" class="ee-rs">
                                            <p class="ee-rs-t">{{ $t('wizard.s2.guarantee-section') }}</p><p class="ee-rs-c">{{ $t('wizard.s2.guarantee-summary-caption') }}</p>
                                            <ul class="ee-rs-l">
                                                <li><span>{{ $t('wizard.s2.guarantee-requested') }}</span><b>{{ d.garantia_meses > 0 ? $t('wizard.s2.guarantee-requested-value', { months: mesesNum(d.garantia_meses) }) : $t('wizard.s2.guarantee-none') }}</b></li>
                                                <li v-if="d.garantia_meses > 0"><span>{{ $t('wizard.s2.guarantee-payment') }}</span><b>{{ d.garantia_pago ? $t(`wizard.s2.guarantee-when-${d.garantia_pago}`) : '—' }}</b></li>
                                                <li class="ee-rs-tot"><span>{{ $t('wizard.s2.guarantee-amount') }}</span><b>{{ montoGarantia ? dinero(montoGarantia, d.moneda) : '—' }}</b></li>
                                            </ul>
                                        </div>
                                    </template>
                                    <div v-if="diario" class="ee-rs ee-rs--day">
                                        <div class="ee-rs-day"><span>{{ $t('wizard.s2.daily-receive') }}</span><b>{{ dinero(diarioRecibe, d.moneda) }}</b></div>
                                        <p v-if="modelo.tipo === 'garantia' && modelo.descuenta" class="ee-rs-c">{{ $t('wizard.s2.daily-receive-caption', { rate: COMISION_LABEL }) }}</p>
                                    </div>
                                </div>
                            </aside>
                        </div>
                    </section>

                    <!-- ══ Fotos ══ -->
                    <section id="sec-fotos" class="ee-card ee-ed-card" aria-labelledby="t-fotos">
                        <div class="ee-card-head">
                            <span class="ee-ed-ico" aria-hidden="true" v-html="ICON.photo"></span>
                            <div><h2 id="t-fotos" class="ee-card-title">{{ $t('editor_espacio.sec.fotos') }}</h2><p class="ee-card-desc">{{ $t('editor_espacio.desc.fotos') }}</p></div>
                            <span v-if="marcas.fotos" class="ee-ed-dirty">{{ $t('editor_espacio.with_changes') }}</span>
                        </div>
                        <div class="ee-pbs">
                            <EeBloque :titulo="$t('editor_espacio.b.fotos')" :ayuda="$t('editor_espacio.b.fotos_c')">
                                <div class="ee-ph-top">
                                    <span class="ee-ph-n"><b>{{ d.fotos.length }}</b> {{ $t('editor_espacio.ph.of12') }}<span v-if="d.fotos.length < 5" class="ee-ph-falta"> · {{ $tc('editor_espacio.ph.missing', 5 - d.fotos.length, { n: 5 - d.fotos.length }) }}</span></span>
                                    <label v-if="d.fotos.length < 12" class="ee-btn ee-btn--ghost ee-btn--sm ee-ph-add"><span v-html="ICON.upload"></span>{{ $t('editor_espacio.ph.add') }}<input type="file" accept="image/png,image/jpeg" multiple class="ee-sr-only" @change="agregarFotos"></label>
                                </div>
                                <ul id="phGrid" class="ee-ph-grid" aria-describedby="phAyuda" @dragover.prevent @drop.prevent>
                                    <li v-for="(f, i) in d.fotos" :key="f.k" :class="['ee-ph', { 'is-drag': arrastrando === i, 'is-over': sobre === i }]" draggable="true"
                                        @dragstart="alArrastrar(i, $event)" @dragover.prevent="sobre = i" @drop.prevent="soltar(i)" @dragend="arrastrando = sobre = null">
                                        <img :src="f.src" :alt="$t('editor_espacio.ph.photo_n', { n: i + 1 })">
                                        <span v-if="i === 0" class="ee-ph-cover">{{ $t('editor_espacio.ph.cover') }}</span>
                                        <span v-else-if="!f.url" class="ee-ph-cover ee-ph-cover--new">{{ $t('editor_espacio.ph.new') }}</span>
                                        <span class="ee-ph-drag" aria-hidden="true" v-html="ICON.drag"></span>
                                        <div class="ee-ph-acts">
                                            <button type="button" class="ee-ph-b" :aria-label="$t('editor_espacio.ph.move_before', { n: i + 1 })" :disabled="!puedeMover(i, i - 1)" @click="mover(i, i - 1, 'izq')" :data-a="'izq'" v-html="ICON.back"></button>
                                            <button type="button" class="ee-ph-b ee-ph-b--r" :aria-label="$t('editor_espacio.ph.move_after', { n: i + 1 })" :disabled="!puedeMover(i, i + 1)" @click="mover(i, i + 1, 'der')" :data-a="'der'" v-html="ICON.back"></button>
                                            <button v-if="i && f.url" type="button" class="ee-ph-b" :aria-label="$t('editor_espacio.ph.make_cover', { n: i + 1 })" @click="hacerPortada(i)" v-html="ICON.star"></button>
                                            <button type="button" class="ee-ph-b ee-ph-b--x" :aria-label="$t('editor_espacio.ph.remove', { n: i + 1 })" @click="quitarFoto(i)" v-html="ICON.trash"></button>
                                        </div>
                                    </li>
                                    <li v-if="d.fotos.length < 12" class="ee-ph ee-ph--add"><label><span v-html="ICON.plus"></span><span>{{ $t('editor_espacio.ph.add_short') }}</span><input type="file" accept="image/png,image/jpeg" multiple class="ee-sr-only" @change="agregarFotos"></label></li>
                                </ul>
                                <p v-if="d.fotos.length < 5" class="ee-error ee-error--on ee-ph-err" role="alert">{{ $t('editor_espacio.ph.min') }}</p>
                            </EeBloque>
                            <ul id="phAyuda" class="ee-pb-tips">
                                <li><span v-html="ICON.drag"></span><span><b>{{ $t('editor_espacio.ph.tip_order_b') }}</b> {{ $t('editor_espacio.ph.tip_order') }}</span></li>
                                <li><span v-html="ICON.star"></span><span><b>{{ $t('editor_espacio.ph.tip_cover_b') }}</b> {{ $t('editor_espacio.ph.tip_cover') }}</span></li>
                                <li><span v-html="ICON.photo"></span><span><b>{{ $t('editor_espacio.ph.tip_format_b') }}</b> {{ $t('editor_espacio.ph.tip_format') }}</span></li>
                            </ul>
                        </div>
                    </section>

                    <!-- ══ Comodidades ══ -->
                    <section id="sec-comodidades" class="ee-card ee-ed-card" aria-labelledby="t-comodidades">
                        <div class="ee-card-head">
                            <span class="ee-ed-ico" aria-hidden="true" v-html="ICON.spark"></span>
                            <div><h2 id="t-comodidades" class="ee-card-title">{{ $t('editor_espacio.sec.comodidades') }}</h2><p class="ee-card-desc">{{ $t('editor_espacio.desc.comodidades') }}</p></div>
                            <span v-if="marcas.comodidades" class="ee-ed-dirty">{{ $t('editor_espacio.with_changes') }}</span>
                        </div>
                        <div class="ee-pbs">
                            <EeBloque v-for="g in COMODIDADES" :key="g.grupo" :titulo="$t(`editor_espacio.am.${g.grupo}`)" :ayuda="$t(`editor_espacio.am.${g.grupo}_c`)">
                                <div class="ee-tg">
                                    <label v-for="[k, l, ic] in g.items" :key="k" class="ee-tg-o">
                                        <input :id="`am-${k}`" v-model="d.caracteristicas[k]" type="checkbox" :true-value="1" :false-value="0">
                                        <span><i class="ee-i" v-html="amen(ic)"></i>{{ $t(`wizard.s4.${l}`) }}</span>
                                    </label>
                                </div>
                            </EeBloque>
                            <EeBloque v-if="d.piezas.length === 0" :titulo="$t('editor_espacio.am.equipo')" :ayuda="$t('editor_espacio.am.equipo_c')">
                                <div class="ee-cts ee-cts--3">
                                    <EeContador v-for="[k, l] in EQUIPO" :id="`st-${k}`" :key="k" v-model="d.estudio[k]" :label="$t(`wizard.room.${l}`)" :max="20" />
                                </div>
                            </EeBloque>
                        </div>
                    </section>

                    <!-- ══ Habitaciones ══ -->
                    <section v-if="d.piezas.length" id="sec-habitaciones" class="ee-card ee-ed-card" aria-labelledby="t-habitaciones">
                        <div class="ee-card-head">
                            <span class="ee-ed-ico" aria-hidden="true" v-html="ICON.bed"></span>
                            <div><h2 id="t-habitaciones" class="ee-card-title">{{ $t('editor_espacio.sec.habitaciones') }}</h2><p class="ee-card-desc">{{ $t('editor_espacio.desc.habitaciones') }}</p></div>
                            <span v-if="marcas.habitaciones" class="ee-ed-dirty">{{ $t('editor_espacio.with_changes') }}</span>
                        </div>
                        <div class="ee-pbs">
                            <details v-for="(p, i) in d.piezas" :key="p.k" class="ee-pb ee-room" :open="i === 0">
                                <summary><span class="ee-room-n">{{ i + 1 }}</span><span class="ee-room-t">{{ $t('wizard.room.room') }} {{ i + 1 }}</span><span class="ee-room-s">{{ resumenPieza(p) }}</span><span class="ee-room-chev" aria-hidden="true"></span></summary>
                                <p class="ee-pb-c">{{ $t('editor_espacio.room_c') }}</p>
                                <div class="ee-cts ee-cts--3">
                                    <EeContador v-for="[k, l] in EQUIPO" :id="`pz-${i}-${k}`" :key="k" v-model="p.equipo[k]" :label="$t(`wizard.room.${l}`)" :max="10" />
                                </div>
                            </details>
                            <p class="ee-hint">{{ $t('editor_espacio.rooms_hint') }} <a href="#sec-basico" class="ee-ed-link" @click.prevent="irASeccion('basico')">{{ $t('editor_espacio.sec.basico') }}</a>.</p>
                        </div>
                    </section>

                    <!-- ══ Cercano a ══ -->
                    <section v-if="!embedded_mode" id="sec-cercano" class="ee-card ee-ed-card" aria-labelledby="t-cercano">
                        <div class="ee-card-head">
                            <span class="ee-ed-ico" aria-hidden="true" v-html="ICON.pin"></span>
                            <div><h2 id="t-cercano" class="ee-card-title">{{ $t('editor_espacio.sec.cercano') }}</h2><p class="ee-card-desc">{{ $t('editor_espacio.desc.cercano') }}</p></div>
                            <span v-if="marcas.cercano" class="ee-ed-dirty">{{ $t('editor_espacio.with_changes') }}</span>
                        </div>
                        <div class="ee-pbs">
                            <EeBloque :titulo="$t('editor_espacio.b.cerca')" :ayuda="$t('editor_espacio.b.cerca_c')">
                                <div class="ee-tg">
                                    <label v-for="[k, l, ic] in CERCANO" :key="k" class="ee-tg-o">
                                        <input :id="`ce-${k}`" v-model="d.cercano[k]" type="checkbox" :true-value="1" :false-value="0">
                                        <span><i class="ee-i" v-html="amen(ic)"></i>{{ $t(`wizard.s6.${l}`) }}</span>
                                    </label>
                                </div>
                            </EeBloque>
                        </div>
                    </section>

                    <!-- ══ Quiénes viven ══ -->
                    <section v-if="!embedded_mode" id="sec-habitantes" class="ee-card ee-ed-card" aria-labelledby="t-habitantes">
                        <div class="ee-card-head">
                            <span class="ee-ed-ico" aria-hidden="true" v-html="ICON.people"></span>
                            <div><h2 id="t-habitantes" class="ee-card-title">{{ $t('editor_espacio.sec.habitantes') }}</h2><p class="ee-card-desc">{{ $t('editor_espacio.desc.habitantes') }}</p></div>
                            <span v-if="marcas.habitantes" class="ee-ed-dirty">{{ $t('editor_espacio.with_changes') }}</span>
                        </div>
                        <div class="ee-pbs">
                            <EeBloque :titulo="$t('editor_espacio.b.viven')" :ayuda="$t('editor_espacio.b.viven_c')">
                                <div class="ee-cts ee-cts--4">
                                    <EeContador v-for="[k, l] in HABITANTES" :id="`hb-${k}`" :key="k" v-model="d.habitantes[k]" :label="$t(`wizard.s7.${l}`)" :max="20" />
                                </div>
                            </EeBloque>
                            <EeBloque :titulo="$t('wizard.s7.about-us')" :ayuda="$t('editor_espacio.b.sobre_c')">
                                <EeTexto id="f-sobre_nosotros" ref="tx_sobre_nosotros" v-model="d.sobre_nosotros" :label="$t('wizard.s7.about-us')" :max="1200" />
                            </EeBloque>
                        </div>
                    </section>

                    <!-- ══ Reglas ══ -->
                    <section v-if="!embedded_mode" id="sec-reglas" class="ee-card ee-ed-card" aria-labelledby="t-reglas">
                        <div class="ee-card-head">
                            <span class="ee-ed-ico" aria-hidden="true" v-html="ICON.rules"></span>
                            <div><h2 id="t-reglas" class="ee-card-title">{{ $t('editor_espacio.sec.reglas') }}</h2><p class="ee-card-desc">{{ $t('editor_espacio.desc.reglas') }}</p></div>
                            <span v-if="marcas.reglas" class="ee-ed-dirty">{{ $t('editor_espacio.with_changes') }}</span>
                        </div>
                        <div class="ee-pbs">
                            <div class="ee-ed-note ee-ed-note--soft"><span v-html="ICON.globe"></span><div><p>{{ $t('editor_espacio.translate_note') }}</p></div></div>
                            <EeBloque v-for="t in TEXTOS" :key="t" :titulo="$t(`editor_espacio.tx.${t}`)" :ayuda="$t(`editor_espacio.tx.${t}_c`)">
                                <EeTexto :id="`f-${t}`" :ref="`tx_${t}`" v-model="d[t]" :label="$t(`editor_espacio.tx.${t}`)" :max="1500" />
                            </EeBloque>
                        </div>
                    </section>
                </div>

                <div class="ee-bar ee-ed-bar" role="region" :aria-label="$t('editor_espacio.save_region')">
                    <span :class="['ee-bar-state', nCambios ? 'is-dirty' : 'is-idle']">{{ esNuevo ? $t('editor_espacio.nuevo.bar') : (nCambios ? $tc('editor_espacio.n_changes', nCambios, { n: nCambios }) : $t('editor_espacio.no_changes')) }}</span>
                    <div class="ee-bar-actions">
                        <button v-if="!nCambios && copiables.length" type="button" class="ee-btn ee-btn--ghost ee-btn--sm" @click="elegirQueCopiar"><span v-html="ICON.layers"></span>{{ $t('editor_espacio.apply_others') }}</button>
                        <button type="button" class="ee-btn ee-btn--ghost" :disabled="!nCambios || guardando" @click="$refs.capas.abrirModal('descartar')">{{ $t(tx('discard')) }}</button>
                        <button type="button" class="ee-btn ee-btn--primary" :disabled="(!esNuevo && !nCambios) || guardando" @click="guardar">
                            <span v-if="guardando" class="ee-spin"></span>{{ $t(tx(guardando ? 'saving' : 'save')) }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <EeCapas ref="capas">
            <template #descartar>
                <div class="ee-modal-ico ee-modal-ico--danger" v-html="ICON.undo"></div>
                <h2 id="ee-modal-t" class="ee-modal-title">{{ $t(tx('discard_t', 'm.')) }}</h2>
                <p class="ee-modal-text">{{ $t(tx('discard_x', 'm.')) }}</p>
                <div class="ee-modal-acts"><button type="button" class="ee-btn ee-btn--ghost" @click="$refs.capas.cerrarModal()">{{ $t('editor_espacio.m.keep') }}</button><button type="button" class="ee-btn ee-btn--danger" autofocus @click="descartar">{{ $t(tx('discard')) }}</button></div>
            </template>
            <template #salir>
                <div class="ee-modal-ico ee-modal-ico--danger" v-html="ICON.info"></div>
                <h2 id="ee-modal-t" class="ee-modal-title">{{ $t('editor_espacio.m.leave_t') }}</h2>
                <p class="ee-modal-text">{{ $t(tx('leave_x', 'm.')) }}</p>
                <div class="ee-modal-acts"><button type="button" class="ee-btn ee-btn--ghost" autofocus @click="quedarse">{{ $t('editor_espacio.m.keep') }}</button><button type="button" class="ee-btn ee-btn--danger" @click="salirSinGuardar">{{ $t('editor_espacio.m.leave_ok') }}</button></div>
            </template>
            <template #tyc>
                <div class="ee-modal-ico" v-html="ICON.shield"></div>
                <h2 id="ee-modal-t" class="ee-modal-title">{{ $t(tx('tyc_t', 'm.')) }}</h2>
                <p class="ee-modal-text">{{ $t('editor_espacio.m.tyc_x') }}</p>
                <ul class="ee-tyc">
                    <li v-for="(x, i) in ['tyc1', 'tyc2', 'tyc3']" :key="x"><label class="ee-ck"><input v-model="tyc[i]" type="checkbox" class="ee-tyc-c"><span v-if="i < 2">{{ $t(`editor_espacio.m.${x}`) }}</span><span v-else>{{ $t('editor_espacio.m.tyc3_a') }} <a href="/tyc" target="_blank" rel="noopener">{{ $t('editor_espacio.m.tyc3_link') }}</a> {{ $t('editor_espacio.m.tyc3_b') }}</span></label></li>
                </ul>
                <div class="ee-modal-acts"><button type="button" class="ee-btn ee-btn--ghost" @click="$refs.capas.cerrarModal()">{{ $t('editor_espacio.cancel') }}</button><button id="mTyc" type="button" class="ee-btn ee-btn--primary" :disabled="!tyc.every(Boolean)" @click="confirmarTyc">{{ $t(tx('tyc_ok', 'm.')) }}</button></div>
            </template>
            <template #copiar>
                <div class="ee-modal-ico" v-html="ICON.layers"></div>
                <h2 id="ee-modal-t" class="ee-modal-title">{{ $t('editor_espacio.apply_others') }}</h2>
                <p class="ee-modal-text">{{ $t('editor_espacio.m.copy_x') }}</p>
                <div class="ee-pick">
                    <label v-for="(o, i) in copiables" :key="i" class="ee-pick-o"><input v-model="copiaElegida" type="radio" name="copiar" :value="i"><span>{{ o.txt }}</span></label>
                </div>
                <div class="ee-modal-acts"><button type="button" class="ee-btn ee-btn--ghost" @click="$refs.capas.cerrarModal()">{{ $t('editor_espacio.cancel') }}</button><button id="mCop" type="button" class="ee-btn ee-btn--primary" autofocus @click="irACopiar">{{ $t('editor_espacio.m.choose_spaces') }}</button></div>
            </template>
        </EeCapas>
    </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapState } from 'vuex';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import { gmapApi } from 'vue2-google-maps';
import HyFLoader from '@/components/Loader/HyFLoader.vue';
import NotFound from '@/pages/General/NotFound.vue';
import { saveRedirectUrl } from '@/Utils/Utils';
import { avisar } from '@/Utils/notificaciones';
import { textoPorIdioma, htmlATexto } from '@/Utils/textoIdiomas';
import EeContador from '@/components/EditorEspacio/EeContador.vue';
import EeBloque from '@/components/EditorEspacio/EeBloque.vue';
import EeTexto from '@/components/EditorEspacio/EeTexto.vue';
import EeCapas from '@/components/EditorEspacio/EeCapas.vue';
import { ICON, amen } from '@/components/EditorEspacio/iconos';
import {
    MODALIDADES, GARANTIA_MESES, GARANTIA_PAGO, COMODIDADES, EQUIPO, CERCANO, HABITANTES, TEXTOS, MONEDAS_RESPALDO, MONEDAS_FUERA,
    COMISION, COMISION_LABEL, roundCustom, dinero, num, modeloAnfitrion, aHtml, clonar, igual, categoriasDe,
} from '@/components/EditorEspacio/datos';

// Qué campos del borrador van en cada sección (para el punto de "con cambios").
const CAMPOS_SECCION = {
    basico: ['tipo', 'categoria', 'modalidad_tiempo', 'm2', 'maximo_huespedes', 'tiempo_min'],
    ubicacion: ['direccion', 'numero', 'latitud', 'longitud', 'dniTexto'],
    precio: ['moneda', 'arriendo', 'arriendo_basicos', 'arriendo_comunes', 'arriendo_limpieza', 'arriendo_diario', 'garantia_meses', 'garantia_pago'],
    fotos: ['fotos'],
    comodidades: ['caracteristicas', 'estudio'],
    habitaciones: ['piezas'],
    cercano: ['cercano'],
    habitantes: ['habitantes', 'sobre_nosotros'],
    reglas: TEXTOS,
};
const SECCIONES = [
    { id: 'basico', icon: 'home' }, { id: 'ubicacion', icon: 'pin' }, { id: 'precio', icon: 'money' }, { id: 'fotos', icon: 'photo' },
    { id: 'comodidades', icon: 'spark' }, { id: 'habitaciones', icon: 'bed' }, { id: 'cercano', icon: 'pin' },
    { id: 'habitantes', icon: 'people' }, { id: 'reglas', icon: 'rules' },
];
// Ayudas del precio: mismos textos que hoy (wizard.s2.*)
const TIPS = {
    moneda: ['wizard.s2.currency-label', 'wizard.s2.currency-info'],
    arriendo: ['wizard.s2.property-expense', 'wizard.s2.property-expense-info'],
    basicos: ['wizard.s2.basic-services', 'wizard.s2.basic-services-info'],
    comunes: ['wizard.s2.common-expenses', 'wizard.s2.common-expenses-info'],
    limpieza: ['wizard.s2.cleaning', 'wizard.s2.cleaning-info'],
    mensual: ['wizard.s2.monthly-rent-value', 'wizard.s2.warranty-info'],
    garantiaVieja: ['wizard.s2.warranty-deposit', 'wizard.s2.warranty-info'],
    diario: ['wizard.s2.daily-lease', 'wizard.s2.daily-info'],
    garantia: ['wizard.s2.guarantee-section', 'wizard.s2.guarantee-info'],
    cuando: ['wizard.s2.guarantee-when', 'wizard.s2.guarantee-when-info'],
    primer: ['wizard.s2.warranty', 'wizard.s2.first-month-info'],
};
const CAMPOS_PRECIO = [
    { k: 'arriendo', label: 'wizard.s2.property-expense-long', tip: 'arriendo', chip: 'wizard.s2.chip-rent' },
    { k: 'arriendo_basicos', label: 'wizard.s2.basic-services-long', tip: 'basicos', chip: 'wizard.s2.chip-services' },
    { k: 'arriendo_comunes', label: 'wizard.s2.common-expenses-long', tip: 'comunes', chip: 'wizard.s2.chip-expenses' },
    { k: 'arriendo_limpieza', label: 'wizard.s2.cleaning-long', tip: 'limpieza', chip: 'wizard.s2.chip-cleaning' },
];
const MAX_MB = 10;
let claveFoto = 0;

function cero(lista, origen) {
    const o = {};
    lista.forEach(([k]) => { o[k] = parseInt(origen && origen[k], 10) || 0; });
    return o;
}
function texto(raw) { return htmlATexto(textoPorIdioma(raw).es || ''); }
function coordValida(lat, lng) {
    const a = parseFloat(lat), b = parseFloat(lng);
    return isFinite(a) && isFinite(b) && Math.abs(a) <= 90 && Math.abs(b) <= 180 && !(a === 0 && b === 0);
}

export default {
    name: 'EditarEspacio',
    components: { HyFLoader, NotFound, VueGoogleAutocomplete, EeContador, EeBloque, EeTexto, EeCapas },
    props: {
        // Carga de unidades de un edificio (WizardUnidades): igual que el wizard
        // viejo en modo embebido, la API copia del edificio la dirección, lo que
        // hay cerca y los textos, así que esas secciones no se muestran.
        propiedad_idpropiedad: { type: Number, default: null },
        embedded_mode: { type: Boolean, default: false },
        unidad: { type: String, default: '' },  // "Unidad 2 de 5" en el lateral
    },
    data() {
        return {
            ICON, amen, dinero, MODALIDADES, GARANTIA_MESES, GARANTIA_PAGO, COMODIDADES, EQUIPO, CERCANO, HABITANTES, TEXTOS, COMISION_LABEL,
            camposPrecio: CAMPOS_PRECIO,
            cargando: true, errorCarga: false, perfilIncompleto: false,
            orig: null, d: null, previo: null,
            archivos: {},           // clave de foto nueva → File (no va en el borrador)
            nombreOriginal: '',     // nombre (.es) tal cual vino: el wizard lo reenvía igual
            localidad: null,        // si se elige otra dirección, el nombre pasa a ser la localidad (como Step1)
            google: null,           // address_data / google_data de la dirección elegida
            aprobado: 0, verificado: 0,
            modelo: modeloAnfitrion(),
            errores: {},
            mapsListo: false,
            centro: null,
            opcionesMapa: { disableDefaultUI: false, scrollwheel: false, minZoom: 2, streetViewControl: false, fullscreenControl: false },
            ayudaK: null, flash: false,
            actual: 'basico',
            arrastrando: null, sobre: null,
            guardando: false, tycOk: false, tyc: [false, false, false],
            copiaElegida: 0,
            salida: null,
        };
    },
    computed: {
        ...mapState('exchange', ['currencyConversionTable', 'visitorCurrency']),
        gm: gmapApi,
        // Sin :idalojamiento en la ruta = agregar un espacio nuevo (POST accommodations/create).
        esNuevo() { return !this.$route.params.idalojamiento; },
        // Al agregar no se marcan "con cambios" las secciones: todo es nuevo.
        marcas() { return this.esNuevo ? {} : this.cambios; },
        monedas() {
            const t = (this.currencyConversionTable || []).map(m => m.moneda).filter(m => m && !MONEDAS_FUERA.includes(m));
            const l = t.length ? t : MONEDAS_RESPALDO;
            return this.d && this.d.moneda && l.indexOf(this.d.moneda) === -1 ? [this.d.moneda, ...l] : l;
        },
        tipos() {
            const base = [
                { value: 'entero', label: this.$t('editor_espacio.tipo.entero'), desc: this.$t('editor_espacio.tipo.entero_d') },
                { value: 'privado', label: this.$t('editor_espacio.tipo.privado'), desc: this.$t('editor_espacio.tipo.privado_d') },
            ];
            // Otro tipo guardado (compartido, cowork…): se muestra para no perderlo.
            if (this.d && !base.some(t => t.value === this.d.tipo)) {
                const k = `search.types.${this.d.tipo}`;
                base.push({ value: this.d.tipo, label: this.$te(k) ? this.$t(k) : this.d.tipo, desc: '' });
            }
            return base;
        },
        categorias() {
            const l = categoriasDe(this.d.tipo);
            return l.length ? l : categoriasDe('entero');
        },
        secciones() {
            const fuera = this.embedded_mode ? ['ubicacion', 'cercano', 'habitantes', 'reglas'] : [];
            return SECCIONES.filter(s => (s.id !== 'habitaciones' || this.d.piezas.length) && !fuera.includes(s.id));
        },
        titulo() {
            const c = this.categorias.find(x => x.value === this.d.categoria);
            const cat = c ? this.$t(c.translated) : '';
            return this.d.tipo === 'entero' ? this.$t('editor_espacio.title_entire', { c: cat }) : this.$t('editor_espacio.title_room', { c: cat.toLowerCase() });
        },
        portada() {
            const f = this.d.fotos[0];
            return f ? f.src : '';
        },
        mensual() { return this.d.modalidad_tiempo !== 'diario'; },
        diario() { return this.d.modalidad_tiempo !== 'mensual'; },
        conGarantia() { return this.modelo.tipo === 'garantia' && this.mensual; },
        total() { return num(this.d.arriendo) + num(this.d.arriendo_basicos) + num(this.d.arriendo_comunes) + num(this.d.arriendo_limpieza); },
        comision() { return this.total > 0 ? roundCustom(this.total * COMISION) : 0; },
        montoGarantia() { const m = num(this.d.garantia_meses); return m > 0 ? roundCustom(this.total * m) : 0; },
        diarioRecibe() {
            const n = num(this.d.arriendo_diario);
            return this.modelo.tipo === 'garantia' && this.modelo.descuenta ? Math.max(0, n - roundCustom(n * COMISION)) : n;
        },
        ayuda() {
            const [t, x] = this.ayudaK ? TIPS[this.ayudaK] : [null, null];
            return t ? { t: this.$t(t), x: this.$t(x) } : { t: this.$t('wizard.s2.tip-eyebrow'), x: this.$t('editor_espacio.tip_default') };
        },
        esCaba() { return !!this.d && this.d.esCaba; },
        posicion() {
            return this.d && coordValida(this.d.latitud, this.d.longitud) ? { lat: parseFloat(this.d.latitud), lng: parseFloat(this.d.longitud) } : this.centro;
        },
        cambios() {
            const r = {};
            if (!this.d) return r;
            Object.entries(CAMPOS_SECCION).forEach(([s, campos]) => {
                const n = campos.filter(c => !igual(this.vista(this.orig, c), this.vista(this.d, c))).length;
                if (n) r[s] = n;
            });
            return r;
        },
        nCambios() { return Object.values(this.cambios).reduce((a, b) => a + b, 0); },
        // Después de guardar: qué cambio se puede copiar a otros espacios (Editar varios).
        copiables() {
            const o = this.previo, d = this.orig, r = [];
            if (!o || !d) return r;
            const P = { arriendo: 'wizard.s2.property-expense', arriendo_diario: 'wizard.s2.daily-lease', arriendo_basicos: 'wizard.s2.basic-services', arriendo_comunes: 'wizard.s2.common-expenses' };
            Object.keys(P).forEach(k => {
                if (num(o[k]) !== num(d[k])) r.push({ tipo: 'precio', txt: `${this.$t(P[k])}: ${dinero(d[k], d.moneda)}`, preset: { campo: k, modo: 'fijar', valor: num(d[k]), moneda: d.moneda } });
            });
            if (o.tiempo_min !== d.tiempo_min && d.modalidad_tiempo !== 'mensual') r.push({ tipo: 'estadia', txt: `${this.$t('editor_espacio.f.min_nights')}: ${d.tiempo_min}`, preset: { valor: d.tiempo_min } });
            if (o.modalidad_tiempo !== d.modalidad_tiempo) r.push({ tipo: 'modalidad', txt: `${this.$t('editor_espacio.b.modalidad')}: ${this.$t('editor_espacio.mod.' + d.modalidad_tiempo)}`, preset: { valor: d.modalidad_tiempo } });
            if (this.modelo.tipo === 'garantia' && (num(o.garantia_meses) !== num(d.garantia_meses) || o.garantia_pago !== d.garantia_pago)) {
                r.push({ tipo: 'garantia', txt: `${this.$t('wizard.s2.guarantee-section')}: ${this.mesesNum(d.garantia_meses)} ${this.mesesUnidad(d.garantia_meses)}`, preset: { meses: num(d.garantia_meses), pago: d.garantia_pago || '15_dias_antes' } });
            }
            if (o.maximo_huespedes !== d.maximo_huespedes) r.push({ tipo: 'huespedes', txt: `${this.$t('editor_espacio.f.max_guests')}: ${d.maximo_huespedes}`, preset: { valor: d.maximo_huespedes } });
            const tx = TEXTOS.filter(t => o[t] !== d[t]);
            if (tx.length) r.push({ tipo: 'reglas', txt: `${this.$t('editor_espacio.sec.reglas')}: ${tx.map(t => this.$t('editor_espacio.tx.' + t).toLowerCase()).join(', ')}`, preset: { textos: Object.fromEntries(tx.map(t => [t, d[t]])), modo: 'reemplazar' } });
            if (o.sobre_nosotros !== d.sobre_nosotros) r.push({ tipo: 'sobre', txt: this.$t('wizard.s7.about-us'), preset: { valor: d.sobre_nosotros, modo: 'reemplazar' } });
            const am = Object.keys(d.caracteristicas).filter(k => o.caracteristicas[k] !== d.caracteristicas[k]);
            if (am.length) r.push({ tipo: 'comodidades', txt: `${this.$t('editor_espacio.sec.comodidades')} (${am.length})`, preset: { cambios: Object.fromEntries(am.map(k => [k, d.caracteristicas[k] ? 'agregar' : 'quitar'])) } });
            const ce = Object.keys(d.cercano).filter(k => o.cercano[k] !== d.cercano[k]);
            if (ce.length) r.push({ tipo: 'cercano', txt: `${this.$t('editor_espacio.sec.cercano')} (${ce.length})`, preset: { cambios: Object.fromEntries(ce.map(k => [k, d.cercano[k] ? 'agregar' : 'quitar'])) } });
            return r;
        },
    },
    watch: {
        nCambios(n) { window.__eeDirty = n > 0; },
        'd.moneda'() { /* el resumen se recalcula solo */ },
    },
    methods: {
        ...mapActions(['checkUserData', 'updateAccommodation', 'createAccommodation']),

        /** Clave del texto: la de "agregar" (editor_espacio.nuevo.*) o la de siempre. */
        tx(k, prefijo = '') { return this.esNuevo ? `editor_espacio.nuevo.${k}` : `editor_espacio.${prefijo}${k}`; },

        // Para comparar: las fotos por su clave; los números como números.
        vista(o, c) {
            const v = o[c];
            if (c === 'fotos') return v.map(f => f.url || f.k);
            if (c === 'piezas') return v.map(p => p.equipo);
            if (['arriendo', 'arriendo_basicos', 'arriendo_comunes', 'arriendo_limpieza', 'arriendo_diario', 'm2', 'garantia_meses'].includes(c)) return v === '' || v === null ? null : num(v);
            return v;
        },

        mesesNum(m) { return String(m).replace('.', this.$i18n.locale === 'en' ? '.' : ','); },
        mesesUnidad(m) {
            m = num(m);
            return m === 0 ? this.$t('wizard.s2.guarantee-none') : m === 0.5 ? this.$t('wizard.s2.guarantee-half') : m === 1 ? this.$t('wizard.s2.guarantee-one') : this.$t('wizard.s2.guarantee-many');
        },
        resumenPieza(p) {
            const e = p.equipo;
            const camas = (e.cama_2_plazas || 0) + (e.cama_1_media_plaza || 0) + (e.cama_1_plaza || 0) + (e.camarote || 0) + (e.sofa_cama || 0);
            return this.$tc('editor_espacio.beds', camas, { n: camas }) + (e.bano_privado ? ' · ' + this.$t('wizard.room.private-bathroom').toLowerCase() : '');
        },
        ayudaDe(k) {
            this.ayudaK = k;
            this.flash = false;
            this.$nextTick(() => { this.flash = true; });
            if (window.innerWidth <= 860 && this.$refs.tipc) this.$refs.tipc.scrollIntoView({ behavior: 'smooth', block: 'center' });
        },

        /* ── Carga ── */
        async cargar() {
            const id = this.$route.params.idalojamiento;
            this.cargando = true;
            this.errorCarga = false;
            try {
                if (this.esNuevo) {
                    // Espacio nuevo: mismos valores iniciales que Step1Wizard / Step2Wizard
                    // (entero, categoría casa, modalidad sin elegir, moneda del visitante).
                    this.desdeApi({
                        step_01: { tipo: 'entero', categoria: 'casa' },
                        step_02: { moneda: this.visitorCurrency || 'USD' },
                        accommodation: { aprobado: 0, verificado: 0 },
                    });
                } else {
                    const { data } = await axios.get(`${process.env.VUE_APP_API_URL}accommodations/logged/${id}`);
                    this.desdeApi(data);
                }
            } catch (e) {
                console.error('[EditarEspacio] no se pudo leer el alojamiento', e);
                this.errorCarga = true;
            } finally {
                this.cargando = false;
            }
            if (!this.errorCarga) this.$nextTick(() => { this.iniciarMapa(); this.$refs.titulo && this.$refs.titulo.focus({ preventScroll: true }); this.espiar(); });
        },
        desdeApi(r) {
            const s1 = r.step_01 || {}, s2 = r.step_02 || {}, a = r.accommodation || {};
            let nombre = '';
            try { nombre = JSON.parse(s1.nombre).es || ''; } catch (e) { nombre = ''; }
            this.nombreOriginal = nombre;
            this.localidad = null;
            this.google = null;
            this.escritaSinElegir = null;
            this._textoElegido = null;
            this.aprobado = a.aprobado;
            this.verificado = a.verificado;
            this.archivos = {};
            const S3 = process.env.VUE_APP_S3_URL;
            const entero = s1.tipo === 'entero';
            const piezas = entero ? [] : (r.step_05 || []).map(p => ({ k: ++claveFoto, idpieza: p.idpieza || null, equipo: cero(EQUIPO, p) }));
            const dni = a.dni && a.dni !== 'null' ? a.dni : null;
            const d = {
                idalojamiento: a.idalojamiento || parseInt(this.$route.params.idalojamiento, 10) || null,
                idcodigo: a.idcodigo || null,
                tipo: s1.tipo || 'entero',
                categoria: s1.categoria || '',
                modalidad_tiempo: s1.modalidad_tiempo || '',
                m2: s1.m2 != null ? parseInt(s1.m2, 10) : '',
                maximo_huespedes: parseInt(s1.maximo_huespedes, 10) || 1,
                tiempo_min: s1.modalidad_tiempo === 'mensual' ? 30 : (parseInt(s1.tiempo_min, 10) || 1),
                direccion: s1.direccion || '',
                numero: s1.numero || '',
                latitud: s1.latitud, longitud: s1.longitud,
                // Igual que Step1: el registro se pide si la dirección es de Argentina.
                esCaba: !!(s1.direccion && String(s1.direccion).toLowerCase().includes('argentina')),
                dniOriginal: dni,
                dniTexto: dni === 'pendiente' ? '' : (dni || ''),
                moneda: s2.moneda || 'USD',
                arriendo: parseInt(s2.arriendo, 10) || 0,
                arriendo_basicos: parseInt(s2.arriendo_basicos, 10) || 0,
                arriendo_comunes: parseInt(s2.arriendo_comunes, 10) || 0,
                arriendo_limpieza: parseInt(s2.arriendo_limpieza, 10) || 0,
                arriendo_diario: parseInt(s2.arriendo_diario, 10) || 0,
                garantia_meses: s2.garantia_meses === null || s2.garantia_meses === undefined || s2.garantia_meses === '' ? null : num(s2.garantia_meses),
                garantia_pago: s2.garantia_pago || null,
                fotos: (r.step_03 || []).map(g => ({ k: 'e' + (++claveFoto), url: g.url, src: S3 + g.url })),
                caracteristicas: cero(COMODIDADES.flatMap(g => g.items), r.step_04),
                estudio: cero(EQUIPO, r.step_04),
                piezas,
                cercano: cero(CERCANO, r.step_06),
                habitantes: cero(HABITANTES, r.step_07),
                sobre_nosotros: texto((r.step_07 || {}).sobre_nosotros),
            };
            TEXTOS.forEach(t => { d[t] = texto((r.step_08 || {})[t]); });
            this.orig = clonar(d);
            this.d = clonar(d);
            this.errores = {};
            this.centro = coordValida(d.latitud, d.longitud) ? { lat: parseFloat(d.latitud), lng: parseFloat(d.longitud) } : null;
        },

        /* ── Mapa y dirección (Google, como hoy) ── */
        iniciarMapa() {
            const listo = window.googleMapsLoaded || this.$gmapApiPromiseLazy();
            listo.then(() => {
                this.mapsListo = true;
                this.$nextTick(() => {
                    if (this.$refs.autocomplete) this.$refs.autocomplete.update(this.d.direccion);
                    if (!this.centro && this.d.direccion) this.ubicarPorDireccion();
                });
            }).catch(() => {});
        },
        ubicarPorDireccion() {
            try {
                new this.gm.maps.Geocoder().geocode({ address: this.d.direccion }, (res, status) => {
                    if (status === 'OK' && res && res[0]) {
                        const l = res[0].geometry.location;
                        this.centro = { lat: l.lat(), lng: l.lng() };
                    }
                });
            } catch (e) { /* sin mapa */ }
        },
        alEscribirDireccion({ newVal }) {
            // Escribir sin elegir una sugerencia no cambia la ubicación (como Step1).
            // Al elegir una sugerencia, Google deja en el campo un texto que puede no
            // ser igual a formatted_address: ese texto también vale como elegido.
            const v = String(newVal || '').trim();
            const elegidos = [this.d.direccion, this._elegida, this._textoElegido].map(x => String(x || '').trim());
            this.escritaSinElegir = elegidos.includes(v) ? null : newVal;
        },
        alElegirDireccion(addr, place) {
            let localidad = '', pais = '', provincia = '', nivel = 0;
            (place.address_components || []).forEach(c => {
                if (c.types.includes('country')) pais = c.long_name;
                if (c.types.includes('locality')) localidad = c.long_name;
                if (c.types.includes('administrative_area_level_1')) provincia = c.long_name;
                for (let n = 5; n >= 1; n--) {
                    if (!localidad && c.types.includes(`administrative_area_level_${n}`) && n > nivel) { nivel = n; }
                }
            });
            if (!localidad) {
                const c = (place.address_components || []).find(x => x.types.some(t => /^(sublocality|administrative_area_level_)/.test(t)));
                localidad = c ? c.long_name : pais;
            }
            this.d.direccion = place.formatted_address || addr.route || this.d.direccion;
            this._elegida = this.d.direccion;
            // Lo que Google escribió en el campo (el componente lo emite justo después)
            const campo = document.getElementById('f-direccion');
            this._textoElegido = campo ? campo.value : null;
            this.escritaSinElegir = null;
            this.d.latitud = addr.latitude;
            this.d.longitud = addr.longitude;
            this.centro = { lat: addr.latitude, lng: addr.longitude };
            this.localidad = localidad;
            this.google = { address_data: addr, google_data: place };
            this.d.esCaba = !!(pais.toLowerCase().includes('argentina') && provincia.toLowerCase().includes('ciudad autónoma de buenos aires'));
            this.$delete(this.errores, 'direccion');
        },
        alMoverMarcador(e) {
            this.d.latitud = +e.latLng.lat().toFixed(7);
            this.d.longitud = +e.latLng.lng().toFixed(7);
        },

        /* ── Lo básico ── */
        cambiarTipo(t) {
            this.d.tipo = t;
            if (t === 'entero') this.d.piezas = [];
            if (!categoriasDe(t).some(c => c.value === this.d.categoria)) this.d.categoria = (categoriasDe(t)[0] || {}).value || '';
        },
        cambiarModalidad(m) {
            this.d.modalidad_tiempo = m;
            // Igual que Step1Wizard: mensual fija 30, diario pone 1, ambos deja el valor.
            if (m === 'mensual') this.d.tiempo_min = 30;
            else if (m === 'diario') this.d.tiempo_min = 1;
            this.$delete(this.errores, 'modalidad_tiempo');
        },
        cambiarHabitaciones(n) {
            while (this.d.piezas.length < n) this.d.piezas.push({ k: ++claveFoto, idpieza: null, equipo: cero(EQUIPO, null) });
            this.d.piezas.splice(n);
        },

        /* ── Fotos ── (la API guarda primero las que ya estaban, en su orden, y
           después las nuevas: por eso una foto nueva no puede ir antes que una
           que ya estaba) */
        esNueva(i) { return !this.d.fotos[i].url; },
        puedeMover(de, a) {
            const f = this.d.fotos;
            if (a < 0 || a >= f.length) return false;
            return this.esNueva(de) === this.esNueva(a);
        },
        mover(de, a, foco) {
            if (!this.puedeMover(de, a)) return;
            const f = this.d.fotos;
            const [x] = f.splice(de, 1);
            f.splice(a, 0, x);
            if (foco) this.$nextTick(() => { const b = this.$el.querySelectorAll('.ee-ph')[a]; const btn = b && b.querySelector(`[data-a="${foco}"]`); if (btn && !btn.disabled) btn.focus(); });
        },
        hacerPortada(i) {
            if (!this.d.fotos[i].url) return;
            const [x] = this.d.fotos.splice(i, 1);
            this.d.fotos.unshift(x);
            this.$refs.capas.toast(this.$t('editor_espacio.t.cover'));
        },
        quitarFoto(i) {
            const [x] = this.d.fotos.splice(i, 1);
            this.$refs.capas.toast(this.$t('editor_espacio.t.photo_removed'), 'info', {
                label: this.$t('editor_espacio.undo'), fn: () => { this.d.fotos.splice(Math.min(i, this.d.fotos.length), 0, x); },
            });
        },
        agregarFotos(ev) {
            const lista = Array.from(ev.target.files || []);
            ev.target.value = '';
            const libres = 12 - this.d.fotos.length;
            const validas = lista.filter(f => /image\/(png|jpe?g)/.test(f.type));
            const chicas = validas.filter(f => f.size <= MAX_MB * 1024 * 1024);
            const grandes = validas.length - chicas.length;
            chicas.slice(0, libres).forEach(f => {
                const k = 'n' + (++claveFoto);
                this.archivos[k] = f;
                this.d.fotos.push({ k, url: null, src: URL.createObjectURL(f) });
            });
            if (grandes) this.$refs.capas.toast(this.$tc('editor_espacio.t.too_big', grandes, { n: grandes }), 'error');
            if (lista.length - validas.length) this.$refs.capas.toast(this.$t('wizard.s3.error-image-format'), 'error');
            if (chicas.length > libres) this.$refs.capas.toast(this.$t('editor_espacio.t.max12'), 'info');
        },
        alArrastrar(i, ev) { this.arrastrando = i; ev.dataTransfer.effectAllowed = 'move'; try { ev.dataTransfer.setData('text/plain', String(i)); } catch (e) { /* IE */ } },
        soltar(i) {
            if (this.arrastrando !== null && this.arrastrando !== i) {
                const de = this.arrastrando;
                if (this.esNueva(de) === this.esNueva(i)) this.mover(de, i);
                else this.$refs.capas.toast(this.$t('editor_espacio.t.new_after'), 'info');
            }
            this.arrastrando = this.sobre = null;
        },

        /* ── Navegación del lateral ── */
        irASeccion(id) {
            const el = document.getElementById('sec-' + id);
            if (!el) return;
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            const f = el.querySelector('input:not([type=hidden]):not(:disabled), select, textarea, button');
            if (f) f.focus({ preventScroll: true });
        },
        espiar() {
            if (this.obs) this.obs.disconnect();
            if (!('IntersectionObserver' in window)) return;
            this.obs = new IntersectionObserver(ents => {
                ents.forEach(en => { if (en.isIntersecting) this.actual = en.target.id.slice(4); });
            }, { rootMargin: '-35% 0px -60% 0px' });
            this.$el.querySelectorAll('.ee-ed-card').forEach(s => this.obs.observe(s));
        },

        /* ── Validación (mismas reglas que el wizard) ── */
        validar() {
            const d = this.d, e = {};
            const req = this.$t('editor_espacio.err.required');
            // Coordenadas guardadas inválidas (hay filas con -99.9999 / -999.9999): vale el
            // punto que el mapa encontró por la dirección, y se guarda ese.
            // Unidad de un edificio: sin dirección ni número (la API pone la del edificio), como el wizard embebido.
            if (!this.embedded_mode) {
                if (!String(d.direccion || '').trim() || !(coordValida(d.latitud, d.longitud) || this.centro)) e.direccion = this.$t('editor_espacio.err.address');
                else if (this.escritaSinElegir && ![d.direccion, this._textoElegido].map(x => String(x || '').trim()).includes(String(this.escritaSinElegir).trim())) e.direccion = this.$t('editor_espacio.err.address');
                if (!String(d.numero || '').trim()) e.numero = req;
            }
            if (!(num(d.m2) >= 1)) e.m2 = req;
            if (!d.categoria) e.categoria = req;
            if (!d.modalidad_tiempo) e.modalidad_tiempo = req;
            if (this.mensual && !(num(d.arriendo) > 0)) e.arriendo = req;
            if (this.diario && !(num(d.arriendo_diario) > 0)) e.arriendo_diario = req;
            if (this.conGarantia) {
                if (d.garantia_meses === null || d.garantia_meses === '') e.garantia_meses = this.$t('wizard.s2.guarantee-error');
                else if (num(d.garantia_meses) > 0 && !d.garantia_pago) e.garantia_pago = this.$t('wizard.s2.guarantee-when-error');
            }
            this.errores = e;
            const malos = Object.keys(e).map(k => document.getElementById('f-' + k) || this.$el.querySelector(`[name="${k}"]`));
            if (d.fotos.length < 5) malos.push(document.getElementById('phGrid'));
            ['sobre_nosotros', ...TEXTOS].forEach(t => {
                const r = this.$refs['tx_' + t];
                const c = Array.isArray(r) ? r[0] : r;
                if (c && !c.validar()) malos.push(document.getElementById('f-' + t));
            });
            return malos.filter(Boolean);
        },

        /* ── Guardar (POST accommodations/update, como el wizard) ── */
        guardar() {
            const malos = this.validar();
            if (malos.length) {
                const el = malos.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top)[0];
                el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                setTimeout(() => el.focus && el.focus({ preventScroll: true }), 350);
                this.$refs.capas.toast(this.$tc('editor_espacio.t.check_fields', malos.length, { n: malos.length }), 'error');
                return;
            }
            if (!this.tycOk) { this.tyc = [false, false, false]; this.$refs.capas.abrirModal('tyc'); return; }
            this.enviar();
        },
        confirmarTyc() { this.tycOk = true; this.$refs.capas.cerrarModal(); this.guardar(); },
        formulario() {
            const d = this.d, f = new FormData();
            const put = (k, v) => f.append(k, v === null || v === undefined ? 'null' : (typeof v === 'boolean' ? (v ? 1 : 0) : v));
            // Paso 1
            put('numero', d.numero);
            put('nombre', this.localidad !== null ? this.localidad : this.nombreOriginal);
            put('m2', d.m2);
            put('maximo_huespedes', d.maximo_huespedes);
            put('tiempo_min', d.modalidad_tiempo === 'mensual' ? 30 : d.tiempo_min);
            put('direccion', d.direccion);
            const punto = coordValida(d.latitud, d.longitud) ? { lat: d.latitud, lng: d.longitud } : (this.centro || { lat: d.latitud, lng: d.longitud });
            put('latitud', punto.lat);
            put('longitud', punto.lng);
            put('tipo', d.tipo);
            put('categoria', d.categoria);
            put('modalidad_tiempo', d.modalidad_tiempo);
            put('tipo_moneda', 'es_CLP');
            put('numeroRegistro', '');
            const place = { compartido: true, privado: true, entero: true };
            if (place[d.tipo] !== undefined) place[d.tipo] = false;
            put('place', JSON.stringify(place));
            put('modality', JSON.stringify({ diario: d.modalidad_tiempo !== 'mensual', mensual: d.modalidad_tiempo !== 'diario', ambos: d.modalidad_tiempo === 'ambos' }));
            if (this.google) { put('address_data', JSON.stringify(this.google.address_data)); }
            // Registro CABA: como Step1 ("pendiente" si está vacío). Fuera de CABA se deja lo que había.
            put('dni', d.esCaba ? (String(d.dniTexto || '').trim() || 'pendiente') : d.dniOriginal);
            // Paso 2
            put('moneda', d.moneda);
            ['arriendo', 'arriendo_basicos', 'arriendo_comunes', 'arriendo_limpieza', 'arriendo_diario'].forEach(k => put(k, parseInt(d[k], 10) || 0));
            put('arriendo_total', this.total);
            if (this.modelo.tipo === 'garantia') {
                put('garantia', this.montoGarantia);
                put('garantia_meses', num(d.garantia_meses));
                put('garantia_pago', num(d.garantia_meses) > 0 ? d.garantia_pago : '');
            } else {
                put('garantia', this.total);
            }
            // Pasos 4, 6 y 7: columnas sueltas (0/1 y cantidades)
            Object.entries(d.caracteristicas).forEach(([k, v]) => put(k, v ? 1 : 0));
            Object.entries(d.estudio).forEach(([k, v]) => put(k, parseInt(v, 10) || 0));
            Object.entries(d.cercano).forEach(([k, v]) => put(k, v ? 1 : 0));
            // Unidad de un edificio: el wizard embebido no tenía los pasos 7 y 8 (la API copia los textos del edificio).
            if (!this.embedded_mode) Object.entries(d.habitantes).forEach(([k, v]) => put(k, parseInt(v, 10) || 0));
            // Textos: la ficha los muestra como HTML; la API los traduce a los 6 idiomas.
            put('sobre_nosotros', aHtml(d.sobre_nosotros));
            if (!this.embedded_mode) TEXTOS.forEach(t => put(t, aHtml(d[t])));
            // Paso 5: habitaciones (la API borra y vuelve a crear las de este alojamiento)
            put('pieza', JSON.stringify(d.tipo === 'entero' ? [] : d.piezas.map(p => ({ idpieza: p.idpieza, ...p.equipo }))));
            put('aprobado', this.aprobado);
            put('verificado', this.verificado);
            // Paso 3: primero las que ya estaban (en su orden), después las nuevas
            d.fotos.filter(x => x.url).forEach(x => f.append('fotos[]', JSON.stringify({ type: 'existing', url: x.url })));
            d.fotos.filter(x => !x.url).forEach(x => { if (this.archivos[x.k]) f.append('fotos[]', this.archivos[x.k]); });
            if (!this.esNuevo) put('id', d.idalojamiento);
            if (this.propiedad_idpropiedad) put('propiedad_idpropiedad', this.propiedad_idpropiedad);
            return f;
        },
        async enviar() {
            if (this.esNuevo) return this.crear();
            this.guardando = true;
            try {
                const resp = await this.updateAccommodation(this.formulario()).catch(err => {
                    // El wizard trata como éxito un error con estado 200/201.
                    if (err.response && (err.response.status === 200 || err.response.status === 201)) return err.response;
                    throw err;
                });
                if (!resp || (resp.status !== 200 && resp.status !== 201)) throw new Error('respuesta inesperada');
                // Lo guardado pasa a ser el original: así se sabe qué cambio se puede copiar a otros espacios.
                this.previo = clonar(this.orig);
                this.orig = clonar(this.d);
                const copia = this.copiables[0] || null;
                const nombre = this.titulo;
                const id = this.d.idalojamiento;
                window.__eeDirty = false;
                this.forzarSalida = true;
                avisar({
                    tipo: 'ok',
                    titulo: this.$t('editor_espacio.t.saved_t'),
                    cuerpo: this.$t('editor_espacio.t.saved_x', { x: nombre, id }),
                    // El cambio se puede copiar a otros espacios desde el mismo aviso (Editar varios).
                    accion: copia ? {
                        label: this.$t('editor_espacio.apply_others'),
                        fn: () => {
                            sessionStorage.setItem('ee_preset', JSON.stringify({ tipo: copia.tipo, ...copia.preset, desde: id }));
                            this.$router.push({ name: 'editar-varios' }).catch(() => {});
                        },
                    } : null,
                });
                this.$router.push({ name: 'my-accommodations' });
            } catch (e) {
                console.error('[EditarEspacio] no se pudo guardar', e, e.response && e.response.data);
                this.$refs.capas.toast(this.$t('editor_espacio.t.save_error'), 'error', { label: this.$t('editor_espacio.retry'), fn: this.enviar, icon: 'repeat' });
            } finally {
                this.guardando = false;
            }
        },

        /* ── Agregar (POST accommodations/create, como el wizard: al terminar va a Mis
           espacios, o avisa a WizardUnidades si es una unidad de un edificio) ── */
        async crear() {
            this.guardando = true;
            try {
                const resp = await this.createAccommodation(this.formulario()).catch(err => {
                    if (err.response && (err.response.status === 200 || err.response.status === 201)) return err.response;
                    throw err;
                });
                if (!resp || (resp.status !== 200 && resp.status !== 201)) throw new Error('respuesta inesperada');
                window.__eeDirty = false;
                this.forzarSalida = true;
                if (this.embedded_mode && this.propiedad_idpropiedad) {
                    this.$emit('unit-created', resp.data);
                    return;
                }
                avisar({ tipo: 'ok', titulo: this.$t('editor_espacio.nuevo.saved_t'), cuerpo: this.$t('editor_espacio.nuevo.saved') });
                this.$router.push({ name: 'my-accommodations' });
            } catch (e) {
                console.error('[EditarEspacio] no se pudo crear', e, e.response && e.response.data);
                this.$refs.capas.toast(this.$t('editor_espacio.nuevo.save_error'), 'error', { label: this.$t('editor_espacio.retry'), fn: this.enviar, icon: 'repeat' });
            } finally {
                this.guardando = false;
            }
        },

        descartar() {
            this.$refs.capas.cerrarModal();
            if (this.esNuevo) this.d.fotos.forEach(f => { if (!f.url && f.src) URL.revokeObjectURL(f.src); });
            Object.values(this.archivos).forEach(() => {});
            this.d = clonar(this.orig);
            this.archivos = {};
            this.errores = {};
            this.localidad = null;
            this.google = null;
            this.centro = coordValida(this.d.latitud, this.d.longitud) ? { lat: parseFloat(this.d.latitud), lng: parseFloat(this.d.longitud) } : this.centro;
            if (this.$refs.autocomplete) this.$refs.autocomplete.update(this.d.direccion);
            this.$refs.capas.toast(this.$t(this.esNuevo ? 'editor_espacio.nuevo.discarded' : 'editor_espacio.t.discarded'), 'info');
        },

        elegirQueCopiar() { this.copiaElegida = 0; this.$refs.capas.abrirModal('copiar'); },
        irACopiar() {
            const o = this.copiables[this.copiaElegida];
            this.$refs.capas.cerrarModal();
            sessionStorage.setItem('ee_preset', JSON.stringify({ tipo: o.tipo, ...o.preset, desde: this.d.idalojamiento }));
            this.$router.push({ name: 'editar-varios' });
        },

        /* ── Salir con cambios sin guardar ── */
        quedarse() { this.salida = null; this.$refs.capas.cerrarModal(); },
        salirSinGuardar() {
            const s = this.salida;
            this.salida = null;
            window.__eeDirty = false;
            this.$refs.capas.cerrarModal();
            this.forzarSalida = true;
            if (s) s();
        },
        antesDeCerrar(ev) { if (this.nCambios) { ev.preventDefault(); ev.returnValue = ''; } },
        irAPerfil() { saveRedirectUrl(this.$route); this.$router.push({ name: 'editar-perfil' }); },
    },
    async created() {
        const ok = await this.checkUserData();
        if (!ok) { this.perfilIncompleto = true; this.cargando = false; return; }
        this.cargar();
    },
    mounted() { window.addEventListener('beforeunload', this.antesDeCerrar); },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.antesDeCerrar);
        if (this.obs) this.obs.disconnect();
        if (this.d) this.d.fotos.forEach(f => { if (!f.url && f.src) URL.revokeObjectURL(f.src); });
        window.__eeDirty = false;
    },
    beforeRouteLeave(to, from, next) {
        if (this.forzarSalida || !this.nCambios || this.guardando) return next();
        this.salida = () => next();
        this.$refs.capas.abrirModal('salir');
        next(false);
    },
    beforeRouteUpdate(to, from, next) {
        if (this.nCambios && !this.forzarSalida) { this.salida = () => { next(); this.$nextTick(this.cargar); }; this.$refs.capas.abrirModal('salir'); return next(false); }
        this.forzarSalida = false;
        next();
        this.$nextTick(this.cargar);
    },
};
</script>

<style src="../../components/EditorEspacio/editorEspacio.css"></style>
<style src="../../components/EditorEspacio/editorAncho.css"></style>
<style>
/* Solo de hyf-front (no está en la demo) */
.ee .ee-cargando { display: grid; place-items: center; min-height: 60vh; }
.ee .ee-cards { display: flex; flex-direction: column; gap: 32px; }
/* Agregar un espacio: tarjeta del lateral sin foto todavía, mapa sin punto y unidad del edificio */
.ee .ee-ed-prev--nuevo { cursor: default; }
.ee .ee-ed-prev--nuevo:hover { transform: none; }
.ee .ee-ed-prev-ph { flex: none; display: grid; place-items: center; width: 76px; height: 76px; border-radius: 12px; background: linear-gradient(135deg, #f4efff, #fff3ea); color: var(--muted); }
.ee .ee-ed-prev-ph svg { width: 26px; height: 26px; }
.ee .ee-ed-map-empty { height: 100%; margin: 0; padding: 24px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px; text-align: center; color: var(--muted); font-size: 14.5px; }
.ee .ee-ed-map-empty span { display: flex; }
.ee .ee-ed-map-empty svg { width: 28px; height: 28px; color: var(--orange-600); }
.ee .ee-ed-unit { margin: 0 0 6px; font-size: 12.5px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; color: var(--orange-600); }
.ee .ee-error--on { display: flex; }
.ee .ee-ph-cover--new { color: var(--violet); }
.ee .ee-ac-input { display: block; width: 100%; height: 60px; margin: 0; padding: 24px 44px 8px 16px; border: 1.5px solid var(--line-2); border-radius: var(--radius); background: #fff; font-size: 16px; color: var(--ink); outline: none; transition: border-color .2s, box-shadow .2s; }
.ee .ee-ac-input:hover { border-color: #cbbcae; }
.ee .ee-ac-input:focus { border-color: var(--orange-500); box-shadow: var(--ring); background: #fffdfb; }
.ee .ee-ac-input:focus + label, .ee .ee-ac-input:not(:placeholder-shown) + label { top: 18px; font-size: 12px; font-weight: 500; }
.ee .ee-ac-input:focus + label { color: var(--orange-600); }
.ee .ee-field.is-invalid .ee-ac-input { border-color: var(--danger); background: #fffafa; }
.ee .ee-ed-map { height: 300px; border-radius: 18px; overflow: hidden; border: 1px solid rgba(29, 26, 23, .08); background: #f1eee9; }
.ee .ee-ed-map .vue-map-container { height: 100%; }
.ee .ee-pf--fs.is-invalid .ee-mo-o span { border-color: var(--danger); }
.ee .ee-ed-note > span { flex: none; display: flex; }
.ee .ee-ed-note > span svg { width: 20px; height: 20px; color: var(--orange-600); }
.ee .ee-ed-ico svg, .ee .ee-snav-link > span:first-child { display: flex; }
.ee .ee-i { display: inline-flex; font-style: normal; }
.ee .ee-hp span, .ee .ee-btn span, .ee .ee-crumb-back span { display: inline-flex; }
@media (max-width: 640px) { .ee .ee-cards { gap: 22px; } .ee .ee-ed-map { height: 220px; } }
/* Google: la lista de sugerencias va sobre el modal/header */
.pac-container { z-index: 1100; }
</style>
